import React from "react";
import { Typography } from "antd";
import Reveal from "../components/common/Reveal";
import HubButton from "../components/common/HubButton";

import masculinoImg from "../assets/images/moda.png";
import femininoImg from "../assets/images/divas.png";
import geralImg from "../assets/images/club.jpeg";
import avatarperfumes from "../assets/images/perfumes.jpeg";


import "../styles/home.css";

const { Title, Paragraph } = Typography;

export default function Home() {
  return (
    <section className="hub-page">
      <div className="hub-container">

        <Reveal>
          <div className="hub-header">
            <Title className="hub-title">
              Bora pro grupo?
            </Title>

            <Paragraph className="hub-description">
              Escolha o grupo e receba as melhores promoções todos os dias.
            </Paragraph>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="hub-buttons">

            {/* Trocamos o 'to' por 'whatsappLink' com o link direto de cada um */}
            <HubButton
              whatsappLink="https://midiapromo.com/zap/promosclubedohomem"
              title="Promos Clube do Homem"
              subtitle="Ofertas diárias e cupons"
              image={masculinoImg}
            />

            <HubButton
              whatsappLink="https://midiapromo.com/zap/promosclubeperfume"
              title="Promos Clube do Perfume"
              subtitle="Ofertas diárias e cupons"
              image={avatarperfumes}
            />

            <HubButton
              whatsappLink="http://midiapromo.com/zap/promosclubedasdivas"
              title="Promos Clube das Divas"
              subtitle="Importados e nacionais"
              image={femininoImg}
            />

            <HubButton
              whatsappLink="https://midiapromo.com/zap/promosclube"
              title="Promos Clube Geral "
              subtitle="Ofertas diárias e cupons"
              image={geralImg}
            />


          </div>
        </Reveal>

      </div>
    </section>
  );
}